// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Importe les styles globaux que nous allons définir
import App from './App'; // Importe le composant App, notre application principale

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Vous pouvez laisser ou supprimer ces lignes si vous n'utilisez pas reportWebVitals
// import reportWebVitals from './reportWebVitals';
// reportWebVitals();